import { render, staticRenderFns } from "./titleOne.vue?vue&type=template&id=73c31bca&scoped=true&"
import script from "./titleOne.vue?vue&type=script&lang=js&"
export * from "./titleOne.vue?vue&type=script&lang=js&"
import style0 from "./titleOne.vue?vue&type=style&index=0&id=73c31bca&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c31bca",
  null
  
)

export default component.exports